import axios from 'axios'

import { fetchEvn, vrsApi } from '../utils/utils'

const baseURL = vrsApi[fetchEvn()]

const appEition = '2.0.8'

class HttpRequest {

    constructor() {
        this.queue = {}
        // 验签
        this.sign = ""
    }

    /**
     * 防止多次请求进行删除
     * @param url 
     */
    destroy(url) {
        delete this.queue[url]
        if (!Object.keys(this.queue).length) {
            // hide loading
        }
    }

    // 发起请求
    async request(options) {
        options.baseURL = baseURL
        let data = options.params || options.data
        // partnerCode
        // 验签
        const instance = axios.create()
        await this.interceptors(instance, options.url)
        return instance(options)
    }

    // 拦截器
    async interceptors(instance, url) {
        // 请求拦截
        instance.interceptors.request.use((config) => {
            // 添加全局的loading...
            if (!Object.keys(this.queue).length) {
                // show loading
            }
            if (url) {
                // 做相同请求同时发起拦截
                // this.queue[url] = true
            }
            config.headers['em-c-version'] = appEition
            config.headers['em-c-origin'] = 'h5'
            return config
        }, (error) => {
            console.error(error)
            return Promise.reject(error)
        })
        // 响应拦截
        instance.interceptors.response.use((res) => {
            if (url) {
                // this.destroy(url)
            }
            const { data } = res
            return Promise.resolve(data)
        }, (error) => {
            if (url) {
                // this.destroy(url)
            }
            console.error(error)
            return Promise.reject(error)
        })
    }
}

export default HttpRequest